export default __webpack_public_path__ + "static/media/Drawkit-Vector-Illustration-Medical-01 1.6912d904.png";